import mutations from './mutations'
import * as getters from './getters'
import * as actions from './actions'

export default {
  state: {
    data: [],
    pageSize: 10
  },
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/news/index.js